import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-profile-container',
  template: '<app-profile></app-profile>',
  styles: []
})
export class ProfileContainerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
